@switch (type()) {
  @case ('stroked') {
    <button
      mat-stroked-button
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      @if (icon()) {
        <mat-icon [ngClass]="iconColorClass() ?? ''">{{ icon() }}</mat-icon>
      }
      {{ label() }}
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      @if (icon()) {
        <mat-icon [ngClass]="iconColorClass() ?? ''">{{ icon() }}</mat-icon>
      }
      {{ label() }}
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      @if (icon()) {
        <mat-icon [ngClass]="iconColorClass() ?? ''">{{ icon() }}</mat-icon>
      }
      {{ label() }}
    </button>
  }
  @default {
    <button
      mat-button
      class="primary-button"
      [color]="color()"
      [class.mat-button-toggle-checked]="checked()"
      [disabled]="disabled()"
      [matTooltip]="tooltip()"
      (click)="buttonClick.emit()"
    >
      @if (icon()) {
        <mat-icon [ngClass]="iconColorClass() ?? ''">{{ icon() }}</mat-icon>
      }
      {{ label() }}
    </button>
  }
}

@switch (type()) {
  @case ('stroked') {
    <button
      mat-stroked-button
      class="menu-button"
      [color]="color()"
      [disabled]="disabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  @case ('flat') {
    <button
      mat-flat-button
      class="menu-button with-divider"
      [color]="color()"
      [disabled]="disabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  @case ('raised') {
    <button
      mat-raised-button
      class="menu-button with-divider"
      [color]="color()"
      [disabled]="disabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
  @default {
    <button
      mat-button
      class="menu-button with-divider"
      [color]="color()"
      [disabled]="disabled()"
      [matMenuTriggerFor]="externalMenu() ?? menu"
    >
      <mat-icon>expand_more</mat-icon>
    </button>
  }
}

<mat-menu #menu="matMenu" xPosition="before" class="side-button-menu">
  <ng-content />
</mat-menu>
